import { BaseDto } from './base.dto';

export class CustomerFavoriteProductDto extends BaseDto {
  customerFavoriteId: number;
  productId: number;
}
